module.exports = __webpack_public_path__ + "static/materia-logo-light-ed5fcdab4f16590987d0f5395b363c94.png";